import React, { FC, Fragment, useContext, useState } from 'react'
import differenceInSeconds from 'date-fns/differenceInSeconds'
import {
    TheWestLiveContext,
    useInProgrammedScheduleWindow,
    queryOverrideOffAir,
} from '../../../../../../content/TheWestLive/TheWestLiveProvider'
import { StyledCountdown, StyledTimer } from './Countdown.styled'
import {
    getLocalTimeFromUTCAtTime,
    humanReadableSeconds,
} from '@news-mono/web-common'
import { useInterval } from '@news-mono/web-common'

export interface CountdownProps {
    className?: string
}

export const Countdown: FC<CountdownProps> = ({ className }) => {
    const theWestLiveContext = useContext(TheWestLiveContext)
    const inScheduledWindow = useInProgrammedScheduleWindow()
    const [timeTillStart, setTimeTillStart] = useState<number | undefined>(
        undefined,
    )
    const localDate = new Date()

    useInterval(() => {
        const startDate = getLocalTimeFromUTCAtTime(
            localDate,
            theWestLiveContext.broadcastSchedules[0].startTime,
        )
        const difference = differenceInSeconds(startDate, localDate)
        if (queryOverrideOffAir) {
            setTimeTillStart(
                difference > 0 ? difference : 300 + (difference % 300),
            )
        } else {
            setTimeTillStart(difference)
        }
    }, 1000)

    return (
        <StyledCountdown className={className}>
            {timeTillStart && timeTillStart >= 0 ? (
                <Fragment>
                    Starts in{' '}
                    <StyledTimer>
                        {humanReadableSeconds(timeTillStart)}"
                    </StyledTimer>
                </Fragment>
            ) : (
                inScheduledWindow && timeTillStart && 'Starts soon'
            )}
        </StyledCountdown>
    )
}
